export enum GAME_STEP {
	Step1,
	Step2,
}
